import Vue from "vue";
import Vuex from "vuex";
import { getCredentials, getUserRole, unauthorizedAction } from "../helpers/commons.helpers";
import { CustomersAPI, OperatorsAPI, BranchesAPI, CountriesAPI, AreasAPI, RatesAPI, ReservationsAPI, VehiclesAPI, UsersAPI, AgentsAPI, TagsAPI, DocumentsAPI, PartnersAPI, ProductsAPI, DestinationsAPI } from "../core/api";
import { QuotesAPI } from "../core/api/quotes.api";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        branchesOptionsByOperatorId: [],
        customerOptions: [],
        customerResponse: {},
        countries: [],
        branchesOptions: [],
        operatorSelections: [],
        reservations: [],
        branchesByOperatorId: {},
        responseReservations: {},
        operatorResponse: {},
        responseBranch: {},
        responseAreaByBranch: {},
        responseArea: {},
        sesion: getCredentials(),
        userRole: getUserRole(),
        load: false,
        profile: {
            first_name: "",
            last_name: "",
            url_picture: "",
            status: false
        },
        areas: [],
        pagination: {},
        vehicles: {},
        vehiclesByBranchId: [],
        drivers: {},
        sigout: false,
        usersResponse: {},
        settings: null,
        rates: {},
        itemsBread: [],
        paginationLimit: 15,
        tempPagination: {
            currenPage: 1,
            query: "",
            queryTemp: "",
            filteredTabStatus: "all",
            limit: 1,
            status: false
        },
        agents: {},
        products: {},
        systemInfo: {
            name: "Mobility",
            year: new Date().getFullYear(),
            release: {
                version: "0.0.0"
            }
        },
        toggled: false,
        duplicatedReservation: null,
        customerSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        supplierSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        branchSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        areaSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        rateSearchCriteria: {
            currentPage: 1,
            branchId: "",
            query: "",
            limit: 15,
            status: false
        },
        vehicleSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        productSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        userSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        partners: {},
        partnerSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        tags: [],
        duplicatedProduct: null,
        cars: {},
        carSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        documents: {},
        documentSearchCriteria: {
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        latestNewsAvailable: false,
        purchaseType: "reservation",
        externalProductSearchCriteria: {
            currentPage: 1,
            countryCode: "",
            categoryId: "",
            destinationSlug: "",
            simpleSearch: "",
            limit: 12,
            products: [],
            status: false
        },
        countriesService: {},
        destinations: {},
        destinationSearchCriteria: {
            destinationType: "CITIES",
            currentPage: 1,
            query: "",
            limit: 15,
            status: false
        },
        quoteResponse: {}
    },
    mutations: {
        setSettings: (state, settings) => {
            sessionStorage.setItem("settings", JSON.stringify(settings));
            state.settings = settings;
        },
        setProfile: (state, profile) => {
            state.profile = profile
        },
        setPagination: (state, pagination) => {
            state.pagination = pagination
        },
        setResponseAreaByBranch: (state, profile) => {
            state.responseAreaByBranch = responseAreaByBranch
        },
        setLoad: (state, load) => {
            state.load = load
        },
        setAreas: (state, areas) => {
            state.areas = areas
        },
        setRatesOfBranch: (state, rates) => {
            state.rates = rates
        },
        setCountries: (state, countries) => {
            state.countries = countries
        },
        setResponseArea: (state, responseArea) => {
            state.responseArea = responseArea
        },
        setOperatorRespose: (state, operatorResponse) => {
            state.operatorResponse = operatorResponse
        },
        setResponseBranch: (state, responseBranch) => {
            state.responseBranch = responseBranch
        },
        setCustomerResponse: (state, customerResponse) => {
            state.customerResponse = customerResponse
        },
        setBranchesOptions: (state, branchesOptions) => {
            state.branchesOptions = branchesOptions
        },
        setReservatios: (state, reservations) => {
            state.reservations = reservations
        },
        setSesion: (state, sesion) => {
            state.sesion = sesion
            if (sesion) {
                state.userRole = sesion.role
            }
        },
        setBranchesByOperatorId: (state, branchesByOperatorId) => {
            state.branchesByOperatorId = branchesByOperatorId
        },
        setBranchesOptionsByOperatorId: (state, branchesOptionsByOperatorId) => {
            state.branchesOptionsByOperatorId = branchesOptionsByOperatorId
        },
        setOperatorSelections: (state, operatorSelections) => {
            state.operatorSelections = operatorSelections
        },
        setResponseReservations: (state, responseReservations) => {
            state.responseReservations = responseReservations
        },
        setVehicles: (state, vehicles) => {
            state.vehicles = vehicles
        },
        setVehiclesByBranchId: (state, vehiclesByBranchId) => {
            state.vehiclesByBranchId = vehiclesByBranchId
        },
        setDrivers: (state, drivers) => {
            state.drivers = drivers
        },
        setSigOut: (state, sigout) => {
            state.sigout = sigout
        },
        setCustomerOptions(state, customerOptions) {
            state.customerOptions = customerOptions
        },
        setItemsBread(state, itemsBread) {
            state.itemsBread = itemsBread
        },
        setTempPagination(state, pagination) {
            state.tempPagination = pagination;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setSystemInfo: (state, systemInfo) => {
            state.systemInfo = systemInfo;
        },
        setToggled: (state, toggled) => {
            state.toggled = toggled;
        },
        setDuplicatedReservation: (state, duplicatedReservation) => {
            state.duplicatedReservation = duplicatedReservation;
        },
        setCustomerSearchCriteria: (state, customerSearchCriteria) => {
            state.customerSearchCriteria = customerSearchCriteria;
        },
        setSupplierSearchCriteria: (state, supplierSearchCriteria) => {
            state.supplierSearchCriteria = supplierSearchCriteria;
        },
        setBranchSearchCriteria: (state, branchSearchCriteria) => {
            state.branchSearchCriteria = branchSearchCriteria
        },
        setAreaSearchCriteria: (state, areaSearchCriteria) => {
            state.areaSearchCriteria = areaSearchCriteria
        },
        setRateSearchCriteria: (state, rateSearchCriteria) => {
            state.rateSearchCriteria = rateSearchCriteria
        },
        setVehicleSearchCriteria: (state, vehicleSearchCriteria) => {
            state.vehicleSearchCriteria = vehicleSearchCriteria
        },
        setProductSearchCriteria: (state, productSearchCriteria) => {
            state.productSearchCriteria = productSearchCriteria
        },
        setUserSearchCriteria: (state, userSearchCriteria) => {
            state.userSearchCriteria = userSearchCriteria
        },
        setPartners: (state, partners) => {
            state.partners = partners
        },
        setPartnerSearchCriteria: (state, partnerSearchCriteria) => {
            state.partnerSearchCriteria = partnerSearchCriteria
        },
        setTags: (state, tags) => {
            state.tags = tags
        },
        setDuplicatedProduct: (state, duplicatedProduct) => {
            state.duplicatedProduct = duplicatedProduct;
        },
        setCars: (state, cars) => {
            state.cars = cars;
        },
        setCarSearchCriteria: (state, carSearchCriteria) => {
            state.carSearchCriteria = carSearchCriteria
        },
        setDocuments: (state, documents) => {
            state.documents = documents
        },
        setDocumentSearchCriteria: (state, documentSearchCriteria) => {
            state.documentSearchCriteria = documentSearchCriteria
        },
        setLatestNewsAvailable: (state, latestNewsAvailable) => {
            state.latestNewsAvailable = latestNewsAvailable
        },
        setPurchaseType: (state, purchaseType) => {
            state.purchaseType = purchaseType;
        },
        setExternalProductSearchCriteria: (state, externalProductSearchCriteria) => {
            state.externalProductSearchCriteria = externalProductSearchCriteria;
        },
        setDestinationSearchCriteria: (state, destinationSearchCriteria) => {
            state.destinationSearchCriteria = destinationSearchCriteria;
        },
    },
    actions: {
        async getSettings({ commit, state }) {
            try {
                let settings = JSON.parse(sessionStorage.getItem('settings'));
                if (settings) {
                    state.settings = settings;
                } else {
                    state.settings = null;
                }
            } catch (error) {
                state.settings = null
            }
        },
        async getGlobalCountries({ commit, state }) {
            try {
                let { data } = await CountriesAPI.getGlobalCountries()
                if (data && data.code === 200) {
                    state.countries = data.data
                } else {
                    state.countries = []
                }
            } catch (error) {
                state.countries = []
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getCustomers({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await CustomersAPI.getCustomers(limit, page, query, state.sesion.token)
                commit("setLoad", false)
                if (data) {
                    state.customerResponse = data
                } else {
                    state.customerResponse = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.customerResponse = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }

        },
        getSesion({ commit, state }) {
            try {
                state.sesion = getCredentials();
                if (state.sesion) {
                    state.userRole = state.sesion.role
                }
            } catch (error) {
                state.sesion = null
                state.userRole = null
            }
        },
        async getOperators({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await OperatorsAPI.getOperators(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.operatorResponse = data
                } else {
                    state.operatorResponse = {}
                }
            } catch (error) {
                state.operatorResponse = {}
                commit("setLoad", false)
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getOperatorsOptions({ commit, state }) {
            try {
                let { data } = await OperatorsAPI.getOperatorsOptions(state.sesion.token)
                if (data.status) {
                    state.operatorSelections = data.data
                } else {
                    state.operatorSelections = []
                }
            } catch (error) {
                state.operatorSelections = []
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getBranchesByOperatorId({ commit, state }, payload) {
            try {
                let { loader, limit, page, operatorId, query } = payload
                commit("setLoad", loader)
                let { data } = await BranchesAPI.getBranchesByOperatorId(operatorId, limit, page, query, state.sesion.token)
                commit("setLoad", false)
                if (data) {
                    state.branchesByOperatorId = data
                } else {
                    state.branchesByOperatorId = {}
                }
            } catch (error) {
                state.branchesByOperatorId = {}
                commit("setLoad", false)
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getBranchesOptionsByOperatorId({ commit, state }, operatorId) {
            try {
                let { data } = await BranchesAPI.getBranchesOptionsByOperatorId(operatorId, state.sesion.token)
                if (data) {
                    state.branchesOptionsByOperatorId = data.data
                } else {
                    state.branchesOptionsByOperatorId = []
                }
            } catch (error) {
                state.branchesOptionsByOperatorId = [];
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getBranches({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await BranchesAPI.getBranches(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.responseBranch = data
                } else {
                    state.responseBranch = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.responseBranch = {}
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getBranchesOptions({ commit, state }) {
            try {
                let { data } = await BranchesAPI.getBranchesOptions(state.sesion.token);
                if (data.status) {
                    state.branchesOptions = data.data;
                } else {
                    state.branchesOptions = [];
                }
            } catch (error) {
                state.branchesOptions = [];
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getRates({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await RatesAPI.getRates(limit, page, query, state.sesion.token)
                commit("setLoad", false)
                if (data) {
                    state.rates = data;
                } else {
                    state.rates = {};
                }
            } catch (error) {
                state.rates = {};
                commit("setLoad", false);
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getRatesByBranchId({ commit, state }, payload) {
            try {
                let { loader, branchId, limit, page, query } = payload
                commit("setLoad", loader);
                let { data } = await RatesAPI.getRatesByBranchId(branchId, limit, page, query, state.sesion.token);
                commit("setLoad", false);
                if (data) {
                    state.rates = data;
                } else {
                    state.rates = {};
                }
            } catch (error) {
                state.rates = {};
                commit("setLoad", false);
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getCustomerOptions({ commit, state }) {
            try {
                let { data } = await CustomersAPI.customerOptions(state.sesion.token)
                if (data) {
                    let customers = data.data || [];
                    state.customerOptions = customers.sort(function (a, b) {
                        if (a.type === "customer" && b.type === "customer") {
                            return a.first_name.localeCompare(b.first_name);
                        } else {
                            return a.company_name.localeCompare(b.company_name);
                        }
                    })
                } else {
                    state.customerOptions = [];
                }
            } catch (error) {
                state.customerOptions = [];
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getReservations({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader);
                let { data } = await ReservationsAPI.getReservations(limit, page, query, state.sesion.token);
                commit("setLoad", false);
                if (data.status) {
                    state.responseReservations = data.data
                } else {
                    state.responseReservations = {}
                }
            } catch (error) {
                commit("setLoad", false);
                state.responseReservations = {}
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getAreas({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await AreasAPI.getAreas(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.responseArea = data;
                } else {
                    state.responseArea = {};
                }
            } catch (error) {
                commit("setLoad", false)
                state.responseArea = {};
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getAreasByBranchId({ commit, state }, payload) {
            try {
                let { loader, branchId, limit, page } = payload
                commit("setLoad", loader);
                let { data } = await AreasAPI.getAreasByBranchId(branchId, limit, page, state.sesion.token)
                commit("setLoad", false);
                if (data) {
                    state.responseAreaByBranch = data;
                } else {
                    state.responseAreaByBranch = {};
                }
            } catch (error) {
                commit("setLoad", false);
                state.responseAreaByBranch = {};
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getAreasOptionsByBranchId({ commit, state }, branchId) {
            try {
                let { data } = await AreasAPI.getAreasOptionsByBranchId(branchId, state.sesion.token)
                if (data) {
                    state.areas = data.data;
                } else {
                    state.areas = []
                }
            } catch (error) {
                state.areas = []
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getVehicles({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await VehiclesAPI.getVehicles(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.vehicles = data;
                } else {
                    state.vehicles = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.vehicles = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getVehiclesByBranchId({ commit, state }, branchId) {
            try {
                let { data } = await VehiclesAPI.getVehiclesByBranchId(branchId, state.sesion.token);
                if (data) {
                    state.vehiclesByBranchId = data;
                } else {
                    state.vehiclesByBranchId = []
                }
            } catch (error) {
                state.vehiclesByBranchId = []
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getUsers({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await UsersAPI.getUsers(limit, page, query, state.sesion.token)
                commit("setLoad", false)
                if (data.status) {
                    state.usersResponse = data.data;
                } else {
                    state.usersResponse = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.usersResponse = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getLimit({ commit, state }) {
            if (localStorage.getItem("pagination-limit")) {
                state.paginationLimit = parseInt(localStorage.getItem("pagination-limit"))
            } else {
                state.paginationLimit = 15
            }
        },
        async getAgents({ commit, state }, payload) {
            try {
                let { customerId, loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await AgentsAPI.getAgents(customerId, limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.agents = data.data
                } else {
                    state.agents = {}
                }
            } catch (error) {
                state.agents = {}
                commit("setLoad", false)
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getProducts({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await ProductsAPI.getProducts(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data.status) {
                    state.products = data.data;
                } else {
                    state.products = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.products = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getTags({ commit, state }, payload) {
            try {
                let { data } = await TagsAPI.getTagsOptions(state.sesion.token);
                if (data) {
                    state.tags = data || [];
                } else {
                    state.tags = []
                }
            } catch (error) {
                state.tags = []
                commit("setLoad", false)
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getToggledMenu({ commit, state }, status) {
            state.toggled = status;
        },
        async getPartners({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await PartnersAPI.getPartners(limit, page, query, state.sesion.token)
                commit("setLoad", false)
                if (data.status) {
                    state.partners = data.data;
                } else {
                    state.partners = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.partners = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getCars({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await VehiclesAPI.getCars(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.cars = data.data;
                } else {
                    state.cars = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.cars = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        async getDocuments({ commit, state }, payload) {
            try {
                let { loader, limit, page, query } = payload
                commit("setLoad", loader)
                let { data } = await DocumentsAPI.getDocuments(limit, page, query, state.sesion.token);
                commit("setLoad", false)
                if (data) {
                    state.documents = data.data;
                } else {
                    state.documents = {}
                }
            } catch (error) {
                commit("setLoad", false)
                state.documents = {}
                let auth = unauthorizedAction(error)
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getCountries: async ({ commit, state }, payload) => {
            try {
                let { loader, limit, page, query } = payload;
                commit("setLoad", loader);
                let { data } = await CountriesAPI.getCountries(limit, page, query, state.sesion.token);
                commit("setLoad", false);
                if (data) {
                    state.countriesService = data.data;
                } else {
                    state.countriesService = {};
                }
            } catch (error) {
                state.countriesService = {};
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getDestinations: async ({ commit, state }, payload) => {
            try {
                let { loader, limit, page, query } = payload;
                commit("setLoad", loader);
                let { data } = await DestinationsAPI.getDestinations(limit, page, query, state.sesion.token);
                commit("setLoad", false);
                if (data) {
                    state.destinations = data.data;
                } else {
                    state.destinations = {};
                }
            } catch (error) {
                state.destinations = {};
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getQuotes: async ({ commit, state }, payload) => {
            try {
                let { loader, limit, page, query } = payload;
                commit("setLoad", loader);
                let { data } = await QuotesAPI.getQuotes(limit, page, query, state.sesion.token);
                commit("setLoad", false);
                if (data) {
                    state.quoteResponse = data;
                } else {
                    state.quoteResponse = {};
                }
            } catch (error) {
                state.quoteResponse = {};
                let auth = unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        }
    },
    getters: {
        customerResponse: state => state.customerResponse,
        branchesOptions: state => state.branchesOptions,
        reservations: state => state.reservations,
        sesion: state => state.sesion,
        userRole: state => state.userRole,
        operatorResponse: state => state.operatorResponse,
        responseArea: state => state.responseArea,
        responseAreaByBranch: state => state.responseAreaByBranch,
        responseBranch: state => state.responseBranch,
        branchesByOperatorId: state => state.branchesByOperatorId,
        branchesOptionsByOperatorId: state => state.branchesOptionsByOperatorId,
        operatorSelections: state => state.operatorSelections,
        countries: state => state.countries,
        customerOptions: state => state.customerOptions,
        responseReservations: state => state.responseReservations,
        load: state => state.load,
        profile: state => state.profile,
        areas: state => state.areas,
        pagination: state => state.pagination,
        vehicles: state => state.vehicles,
        vehiclesByBranchId: state => state.vehiclesByBranchId,
        drivers: state => state.drivers,
        sigout: state => state.sigout,
        usersResponse: state => state.usersResponse,
        settings: state => state.settings,
        rates: state => state.rates,
        itemsBread: state => state.itemsBread,
        paginationLimit: state => state.paginationLimit,
        tempPagination: state => state.tempPagination,
        agents: state => state.agents,
        products: state => state.products,
        systemInfo: state => state.systemInfo,
        toggled: state => state.toggled,
        duplicatedReservation: state => state.duplicatedReservation,
        customerSearchCriteria: state => state.customerSearchCriteria,
        supplierSearchCriteria: state => state.supplierSearchCriteria,
        branchSearchCriteria: state => state.branchSearchCriteria,
        areaSearchCriteria: state => state.areaSearchCriteria,
        rateSearchCriteria: state => state.rateSearchCriteria,
        vehicleSearchCriteria: state => state.vehicleSearchCriteria,
        productSearchCriteria: state => state.productSearchCriteria,
        userSearchCriteria: state => state.userSearchCriteria,
        partners: state => state.partners,
        partnerSearchCriteria: state => state.partnerSearchCriteria,
        tags: state => state.tags,
        duplicatedProduct: state => state.duplicatedProduct,
        cars: state => state.cars,
        carSearchCriteria: state => state.carSearchCriteria,
        documents: state => state.documents,
        documentSearchCriteria: state => state.documentSearchCriteria,
        latestNewsAvailable: state => state.latestNewsAvailable,
        purchaseType: state => state.purchaseType,
        externalProductSearchCriteria: state => state.externalProductSearchCriteria,
        countriesService: state => state.countriesService,
        destinations: state => state.destinations,
        destinationSearchCriteria: state => state.destinationSearchCriteria,
        quoteResponse: state => state.quoteResponse
    }
});